import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { LinearProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Snackbar from '@mui/material/Snackbar';
import { createTheme, styled, useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { visuallyHidden } from '@mui/utils';
import { useAtom } from 'jotai';
import { Parser } from 'json2csv';
import moment from 'moment';
import React from 'react';
import { baseAtom } from '../../stores/jotai/base';
import { CustomSearch } from './customSearch';

//@ts-ignore
JSON.safeStringify = (obj, indent = 2) => {
  let cache = [];
  //@ts-ignore
  const retVal = JSON.safeStringify(
      obj,
      (key, value) =>
          typeof value === "object" && value !== null
              ? cache.includes(value)
                  ? undefined // Duplicate reference found, discard key
                  : cache.push(value) && value // Store value in our collection
              : value,
      indent
  );
  cache = null;
  return retVal;
};

function domDownload(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();
console.log("Ami issue 6")
  document?.body?.removeChild(element);
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    background: theme?.custom?.hoverOptionColor, // Example: Use a color from the theme
  },
}));


function EnhancedTableHead(props) {
  const { order, orderBy, rowCount, onRequestSort, headCells, columnStyles } =
    props;
  const theme = useTheme();
  const createSortHandler = (property) => (event) => {
    onRequestSort(property);
  };

  return (
    <TableHead>
      <TableRow sx={columnStyles}>
        {headCells?.map((headCell) => (
          <TableCell
            key={headCell?.id}
            align={headCell?.align}
            sortDirection={orderBy === headCell?.id ? order : false}
            id={headCell?.id}
            sx={{ fontWeight: 'bold', padding: '6px', borderBottom: `1px solid ${theme?.custom?.borderGrey}` }}
          >
            {props?.minimal ? headCell?.label : <TableSortLabel
              active={orderBy === headCell?.id}
              direction={orderBy === headCell?.id ? order : 'asc'}
              onClick={createSortHandler(headCell?.id)}
            >
              {headCell?.label}
              {orderBy === headCell?.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props) {
  const {
    tableRows,
    headCells,
    tableName,
    columnStyles,
    disablePagination,
    headerStyles,
    tableStyles = {},
    hideToolbar = false,
  } = props;

  const [localError, setLocalError] = React.useState(null);

  let tableRowsLength = 0;

  try {
    tableRowsLength = tableRows?.length;
  }
  catch (e) {

  }

  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('date');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(disablePagination ? tableRowsLength : 10);
  const [archivedRows, setArchivedRows] = React.useState([])
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [popperDetails, setPopperDetails] = React.useState(null)
  const [clipboardMessageOpen, setClipboardMessageOpen] = React.useState(false)
  const [archiveUndoOpen, setArchiveUndoOpen] = React.useState(false)
  const [tableEntries, setTableEntries] = React.useState({ all: tableRows, results: tableRows });
  const theme = useTheme();
  // watch for incoming data changes
  React.useEffect(() => {
    setTableEntries((t) => {
      return {
        all: props?.tableRows,
        results: props?.tableRows
      }
    })
  }, [props?.tableRows]);

  const getLinksForDetail = (linksObj) => {
    let formattedLinks = []
    if (linksObj === null){
      return []
    }

    linksObj.props.title.props.children.props.children.forEach(l => {
      formattedLinks.push(l.props.children[0] + l.props.children[1].props.children + ' ' + l.props.children[2].props.children)
    })
    return formattedLinks
  } 

  const getCreatorForDetail = (row) => {
    let formattedCreatorObj = {}

    formattedCreatorObj['interviewee'] = row?.interviewee?.props?.title
    formattedCreatorObj['name'] = row?.avatar?.props?.title
    formattedCreatorObj['avatar'] = row?.avatar?.props?.children?.props?.src

    return formattedCreatorObj
  }


  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property)
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const handleShowAlt = (event, row) => {
    if (row[`${event.target.id}Alt`]) {
      setAnchorEl(event.currentTarget)
      setPopperDetails(row[`${event.target.id}Alt`])
    }
  }

  const handleHideDetail = event => {
    setAnchorEl(null)
  }

  const popperOpen = Boolean(anchorEl)

  const genericTableSearch = (entries, searchValue) => {
    let results = []

    if (searchValue === undefined || searchValue === null || searchValue === "") {
      return entries;
    }

    for (let i = 0; i < entries?.length; i++) {
      //@ts-ignore
      if (JSON.safeStringify(entries[i]).toLowerCase().includes(searchValue.toLowerCase())) {
        results.push(entries[i])
      }
    }

    return results;
  }

  const genericTableSort = (order, orderBy, entries) => {
    // If the structure of materialData changes, this must also change
    if (order === 'asc') {
        switch (orderBy) {
            case 'date':
                return entries.sort((a, b) => moment(a.created).diff(moment(b.created)))

        }

        return entries.sort((a, b) => {
            return a[orderBy] > b[orderBy] ? 1 : -1;
        })
    }
    if (order === 'desc') {
        switch (orderBy) {
            case 'date':
                return entries.sort((a, b) => moment(b.created).diff(moment(a.created)))

        }

        return entries.sort((a, b) => {
            return a[orderBy] > b[orderBy] ? -1 : 1;
        })
    }

    return entries
}

  const handleCloseClipboardMessage = event => {
    setClipboardMessageOpen(false)
  }
  const clipboardAction = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleCloseClipboardMessage}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  )
  const handleCloseArchiveMessage = (event) => {
    setArchiveUndoOpen(false)
  }
  const handleUndo = () => {
    setArchivedRows(prevState => {
      prevState.pop()
      return prevState
    })
    setArchiveUndoOpen(false)
  }
  const archiveAction = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={handleUndo}>
        UNDO
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseArchiveMessage}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableEntries.results.length) : 0;

  const getColumns = () => {
    let ids = []
    for (let i = 0; i < headCells?.length; i++) {
      ids.push({ id: headCells[i]?.id, aligned: headCells[i]?.align })
    }
    return ids
  }
  const columns = getColumns()

  const textContent = (elem: React.ReactElement | string) => {
    if (!elem) {
      return '';
    }
    if (typeof elem === 'string') {
      return elem;
    }

    const children = elem.props && elem.props.children;
    if (children instanceof Array) {
      return children.map(textContent).join('');
    }
    return textContent(children);
  }

const handleExport = (exportData) => {
  interface ITag {
      customFindingTypeID: string;
      label: string;
      color: string;
      state: number;
      options: ITagOptions;
      deleted: number;
      favorited: string;
  }
  interface ITagOptions {
      favorited: boolean;
      visibility: boolean;
  }
  interface ILink {
      linkID: string
      supports: number
      category: ILinkCategory
  }
  interface ILinkCategory {
      name: string
      description: string
      abbreviation: string
      entry: IEntry
  }
  interface IEntry {
      entryID: string
      entry: string
  }
  const getQuote = (quote: string) => {
      try {
          const parsedQuote = JSON.parse(quote);
          return parsedQuote.textCache;
      } catch (e) {
          console.error(e)
          return '';
      }
  }
  const getInsightType = (tags: ITag[]) => {
      if (!tags?.length) return '';
      const insightTypes = tags.map((tag) => tag.label);
      return insightTypes.join(', ');
  }
  const getLinks = (links: ILink[]) => {
      if (!links?.length) return '';
      const linkCategories: string[] = [];
      links.forEach((link) => {
          const categoryName = link?.category?.name;
          if (categoryName) linkCategories.push(categoryName)
      })
      return linkCategories.join(', ');
  }
  const ratingValues = {
    5: 'Critical',
    4: 'High',
    3: 'Medium',
    2: 'Low',
    1: 'Low'
};
  try {
      const data = exportData?.map((dataItem) => ({
          date: dataItem?.selectedFinding?.created?.split(' ').slice(0, 4).join(' '),
          interviewee: dataItem?.selectedFinding?.interviewee,
          comment: dataItem?.selectedFinding?.comment,
          quote: getQuote(dataItem?.selectedFinding?.quote),
          insightType: getInsightType(dataItem?.selectedFinding?.tags),
          links: getLinks(dataItem?.selectedFinding?.links),
          rating: dataItem?.selectedFinding?.rating?.global?.rating ? ratingValues[dataItem?.selectedFinding?.rating?.global?.rating] : ''
      }));

      const fields = Object.keys(data[0]);
      const opts = { fields };
      const _parser = new Parser(opts);
      const _csv = _parser.parse(data);
      domDownload(`Discovery Data Export - ${new Date().toISOString()}.csv`, _csv);
  }
  catch (e) {
      setLocalError(e.toString());
  }
}


  const getClickPayload = (row) => {
    // console.log(row)
    if (props.minimal === true) {
      return { data: row['templateID'] }
    }
    else {
      props.onSelectRow(row)
    }
  }

  const emptyCell = <Box></Box>
  const renderRowInternal = (c, __row) => {
    // check for empty row
    if (__row[c.id] === undefined || __row[c.id] === null) {
      return emptyCell;
    }

    // check to see if our cell is a direct child, or a breakout
    let tableCellRenderResult = undefined;;

    // if it matches the signature of a "breakout" cell use it's render method
    if (typeof __row[c.id][1] === "function") {
      tableCellRenderResult = __row[c.id][1]();
    }
    else {
      // otheriwse just assume it's JSX and render it as is
      tableCellRenderResult = __row[c.id];
    }

    return tableCellRenderResult;
  }

  if (props.minimal === true) {
    return <TableContainer sx={{ height: '90%', ...tableStyles }}>
      <Table
        sx={{ minWidth: 250, tableLayout: 'fixed' }}
        aria-labelledby="tableTitle"
        // size={dense ? 'small' : 'medium'}
        size="small"
      >
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={tableRowsLength}
          headCells={headCells}
          columnStyles={columnStyles}
          minimal={props.minimal}
        />
        <TableBody >

          {tableEntries?.results ? tableEntries?.results?.map((row, index) => {
            if (archivedRows?.includes(row[props.uniqueCol])) {
              return (
                <TableRow
                  sx={{
                    // height: (dense ? 53 : 73),
                    height: 53,
                    bgcolor: '#778f9d',
                  }}
                  key={row[props.uniqueCol]}
                >
                  <TableCell colSpan={columns?.length + 2} sx={{ textAlign: 'center', color: 'lightgray' }} >
                    Archived
                  </TableCell>
                </TableRow>
              )
            } else {
              return (
                <StyledTableRow
                  tabIndex={-1}
                  key={row?.id || row?.[props.uniqueCol] || `row-${index}`}
                >
                  {columns.map((c, i) => {
                    let __row = renderRowInternal(c, row);

                    return <TableCell
                      key={c.id}
                      id={c.id}
                      sx={{
                        padding: '6px',
                        backgroundColor: props.selectedRow && props.selectedRow.id === row.id ? '#1565c0' : 'inherit',
                        color: props.selectedRow && props.selectedRow.id === row.id ? 'white' : 'inherit'
                      }}
                      onClick={() => {
                         props.onSelectRow(row);
                      }}
                      onMouseOver={(event) => handleShowAlt(event, row)}
                      onMouseLeave={handleHideDetail} align={c.aligned}>
                      {__row}
                    </TableCell>
                  })}
                </StyledTableRow>
              )
            }
          }) : <LinearProgress />}
          {emptyRows > 0 && (
            <TableRow
              style={{
                // height: (dense ? 33 : 53) * emptyRows,
                height: 33 * emptyRows,
              }}
            >
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  }

  let sortPointer = props.customSort ? props.customSort : genericTableSort;

  return (
    <Box sx={{ height: '100%' }}>
      <Snackbar
        open={localError !== null}
        autoHideDuration={6000}
        onClose={() => {
          setLocalError(null);
        }}
        message={localError}
      />
      <Popper open={popperOpen} anchorEl={anchorEl} placement="top" transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <Typography component={'div'} sx={{ p: 2, width: 220 }}>{popperDetails}</Typography>
            </Paper>
          </Fade>
        )}
      </Popper>
      <Snackbar
        open={clipboardMessageOpen}
        autoHideDuration={2000}
        onClose={handleCloseClipboardMessage}
        message="Copied to clipboard"
        action={clipboardAction}
      />
      <Snackbar
        open={archiveUndoOpen}
        autoHideDuration={4000}
        onClose={handleCloseArchiveMessage}
        message="Entry deleted"
        action={archiveAction}
      />
      <Paper sx={{ width: '100%', height: '100%', mb: 2, overflow: 'hidden', borderRadius: '0px' }}>
        {!hideToolbar && (
          <CustomToolbar
            onExport={(data) => handleExport(data)}
            tableName={tableName}
            headerStyles={headerStyles}
            tableEntries={tableEntries}
            setTableEntries={setTableEntries}
            customSearch={
              props?.customSearch ? props?.customSearch : genericTableSearch
            }
          />
        )}
        <TableContainer sx={{ height: '100%',border: `1px solid ${theme?.custom?.borderGrey}`,borderRadius:'3px', ...tableStyles }}>
          <Table
            sx={{ minWidth: 250, tableLayout: 'fixed', width: '100%' }}
            aria-labelledby="tableTitle"
            // size={dense ? 'small' : 'medium'}
            size='small'
            stickyHeader
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={tableRowsLength}
              headCells={headCells}
              columnStyles={columnStyles}
            />
            <TableBody >

              {sortPointer(order, orderBy, tableEntries?.results)?.map((row, index) => {
                if (archivedRows.includes(row[props.uniqueCol])) {
                  return (
                    <TableRow
                      sx={{
                        // height: (dense ? 53 : 73),
                        height: 53,
                        bgcolor: '#778f9d',
                      }}
                      key={row?.id || row[props.uniqueCol] ||  `archived-${index}`}
                    >
                      <TableCell colSpan={columns?.length + 2} sx={{ textAlign: 'center', color: 'lightgray' }} >
                        Archived
                      </TableCell>
                    </TableRow>
                  )
                } else {
                  return (
                    <StyledTableRow
                      tabIndex={-1}
                      key={row?.id ||  `archived-${index}` || row[props.uniqueCol]}
                    >

                      {columns.map((c, i) => {
                        let __row = renderRowInternal(c, row);

                        // console.log(row)
                        return <TableCell
                          key={c.id}
                          id={c.id}
                          sx={{
                            padding: '6px',
                            backgroundColor: props.selectedRow && props.selectedRow.id === row.id ? '#1565c0' : 'inherit',
                            color: props.selectedRow && props.selectedRow.id === row.id ? 'white' : 'inherit'
                          }}
                          onClick={() => props.onSelectRow ? getClickPayload(row) /* props.onSelectRow({ id: row.id, quote: row.quote.props.children, comment: row.comment.props.children, links: getLinksForDetail(row.links), creator: getCreatorForDetail(row) }) */ : null}
                          onMouseOver={(event) => handleShowAlt(event, row)}
                          onMouseLeave={handleHideDetail} align={c.aligned}>
                          {__row}
                        </TableCell>
                      })}
                    </StyledTableRow>
                  )
                }
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    // height: (dense ? 33 : 53) * emptyRows,
                    height: 33 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
              {/* // layout padding */}
              <TableRow>
                <TableCell sx={{ borderBottom: 'none', padding: 0 }}>
                    <Box sx={{ height: '64px', width: '100%' }} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {disablePagination ? undefined : <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={tableEntries?.results?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />}
      </Paper>
    </Box>
  )
}

export function CustomToolbar(props) {
  const [searchValue, setSearchValue] = React.useState('')
  const theme = useTheme();
  React.useEffect(() => {
    let results = props.customSearch(props.tableEntries.all, searchValue)

    props.setTableEntries(prev => ({ results: results, all: prev.all }))
  }, [searchValue])

  return (
    <Toolbar
      sx={{
        bgcolor: theme?.custom?.mainBackgroundColor,
        pl: { sm: 2 },
        pr: { xs: 0, sm: 0 },
        width: '100%',
        ...props.headerStyles,

      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        {props?.tableName} ({props?.tableEntries?.results?.length})
        {
          props?.tableEntries?.results?.length > 0 ? (
            <Tooltip title="Export">
              <IconButton
                onClick={() => {
                  if (props?.onExport) {
                    props.onExport(props?.tableEntries?.results);
                  }
                }}
              >
                <FileDownloadIcon />
              </IconButton>
            </Tooltip>
          ) : null
        }
      </Typography>

      <CustomSearch inputValue={searchValue} updateInputValue={(newVal) => setSearchValue(newVal)} expandable styles={{ container: { height: '38px',width:'265px' }, input: {} }} />
    </Toolbar>
  )
}
